<template>
    <v-dialog v-model="dialog" max-width="430" :fullscreen="$vuetify.breakpoint.xs">
        <v-card class="py-8 px-11">
            <h2 class="text-center">Are you sure?</h2>
            <p class="text-center font-weight-bold mt-3">If you delete this subject will be removed all related data etc...</p>
            <v-card-actions class="d-flex justify-center">
                <v-btn class="green white--text mr-4" type="submit" :loading="loadingRequest" @click="deleteSubject">Agree</v-btn>
                <v-btn class="transparent green--text ml-4" @click="dialog = false">Disagree</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        props: ['subject_id'],
        data(){
            return {
                dialog: false,
                loadingRequest: false,
            }
        },

        methods: {
            deleteSubject(){
                this.loadingRequest = true;
                this.$apiAdmin('subjects').delete(this.subject_id)
                    .then(() => {
                        this.$parent.$emit('getSubjects');
                        this.$store.dispatch('alert', {type: 1, message: 'Successfully deleted.'});
                    }).finally(() => {
                    this.loadingRequest = false;
                    this.dialog = false;
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../../scss/components/dialog";
</style>